import { incYenOf, incOf } from '../lib/pricing';
export const aboutHero = {
  title: 'アカデミーについて',
  titleEn: 'ABOUT THE ACADEMY',
  lead: '日本執事アカデミーは、全日本執事協会が運営する日本で唯一の本格的な執事育成機関です。',
};

export const aboutTrustBadges = [
  {
    icon: 'ri-shield-user-line',
    text: '一般社団法人 全日本執事協会 運営',
  },
  {
    icon: 'ri-building-4-line',
    text: '東京・お台場に校舎を構える',
  },
  {
    icon: 'ri-calendar-check-line',
    text: '土日開催・定員6名の少人数制',
  },
];

export const aboutUsParagraphs = [
  '執事は、ただ家事をこなす職業ではありません。先を読み、場を整え、相手が口にする前に動く——その技術と心構えを体系立てて学べる場として、日本執事アカデミーは生まれました。',
  '伝統的な執事の技能と現代のサービス業界が求める実践力を融合させた独自のカリキュラムにより、座学にとどまらない「動ける執事」を育成します。授業は実技を中心に構成され、受講生の皆様一人ひとりに講師の目が行き届く完全少人数制（定員6名）を採用。お仕事を続けながら学べるよう、すべての授業を土日に開催しています。',
  'カリキュラムはエッセンシャル・アドバンス・マスターの3段階構成で、上位コースほど下位コースの内容を含みます。目的に応じて1つのコースをお選びいただくだけで、基礎から応用、そして管理と危機対応までを体系的に学べます。',
  '講師陣は、国内外の現場で執事としての経験を積んだプロフェッショナルです。実務で培った所作と判断力を、体系化された「型」としてお伝えし、修了後すぐに現場で活かせる力を育みます。',
];

export const fourFeatures = [
  {
    icon: 'ri-group-line',
    title: '実践重視の少人数教育',
    description:
      '定員6名の完全少人数制。実技中心のカリキュラムにより、講師が受講生一人ひとりの所作を細部まで確認し、確実な習得へと導きます。座学で終わらせず、「体が覚えるまで」繰り返すことを大切にしています。',
  },
  {
    icon: 'ri-book-open-line',
    title: '体系化されたカリキュラムと教材',
    description:
      '伝統的な執事技能を現代のニーズに合わせて再編し、段階的に学べる教材として体系化。なぜその所作が必要なのか——理論と実践の両面から理解を深め、応用力を養います。',
  },
  {
    icon: 'ri-award-line',
    title: '協会認定資格への道',
    description:
      '所定の課程を修了し審査に合格することで、全日本執事協会認定のバトラー資格を取得できます。プロフェッショナルとしての信頼の証であり、キャリア形成の基盤となる資格です。',
  },
  {
    icon: 'ri-calendar-2-line',
    title: '働きながら学べる土日開催',
    description:
      'すべての授業を土日に開催。現職を離れることなく、週末を活用して専門性を高められます。転職や独立を見据えたキャリアアップの選択肢として、働きながら学べる環境をご用意しています。',
  },
];

export const academyOverviewLinks = [
  {
    icon: 'ri-lightbulb-line',
    title: '教育理念・方針',
    description: '私たちが大切にする教育の考え方',
    href: '/philosophy',
  },
  {
    icon: 'ri-organization-chart',
    title: '全日本執事協会について',
    description: '運営母体と提供する事業のご紹介',
    href: '/association',
  },
  {
    icon: 'ri-building-line',
    title: '施設・設備紹介',
    description: 'お台場の本校と実習環境',
    href: '/facilities',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'アクセス',
    description: '校舎への行き方と完全予約制のご案内',
    href: '/access',
  },
  {
    icon: 'ri-stack-line',
    title: 'コース一覧・比較',
    description: '3つのコースの違いを一覧で確認',
    href: '/courses',
  },
  {
    icon: 'ri-road-map-line',
    title: 'カリキュラム概要',
    description: '学びの全体像と進め方',
    href: '/curriculum',
  },
];

export const threeCourses = [
  {
    title: 'エッセンシャル',
    titleEn: 'Essential',
    duration: '1ヶ月',
    days: '全8日間',
    hours: '48時間',
    price: incYenOf('ac-essential'),
    description:
      '執事の基本所作と接遇の型を集中的に学ぶ入門コース。おもてなしの基礎を確実に身につけ、サービス業でのキャリアアップを目指す方に最適です。',
    href: '/courses/essential',
  },
  {
    title: 'アドバンス',
    titleEn: 'Advanced',
    duration: '2ヶ月',
    days: '全12日間',
    hours: '72時間',
    price: incYenOf('ac-advanced'),
    description:
      'エッセンシャルの全内容を含んだ上で、本物のサービスをゲストとして体験する特別実習やより高度な接遇技術まで習得する中級コース。未経験からの直接受講も可能で、働きながら専門性を高められる設計です。',
    href: '/courses/advanced',
    recommended: true,
  },
  {
    title: 'マスター',
    titleEn: 'Master',
    duration: '3ヶ月',
    days: '全16日間',
    hours: '96時間',
    price: incYenOf('ac-master'),
    description:
      'エッセンシャル・アドバンスの全内容を含んだ上で、管理・危機対応までを網羅する最上級コース。未経験からの直接受講も可能で、執事としての総合力を完成させます。',
    href: '/courses/master',
  },
];

export const aboutFaqs = [
  {
    question: 'どんな人が対象ですか？',
    answer:
      '初心者からプロ志望の方まで対象です。上位コースは下位コースの内容を含むため、目的に応じて1つのコースをお選びいただくだけで必要な内容を一通り学べます。執事として新たにキャリアを始めたい方、ホテル等で専門性を高めたい方など、幅広い目的に対応する3つのコースをご用意しています。',
  },
  {
    question: '働きながら通えますか？',
    answer:
      'はい。授業は土日開催・完全少人数制（定員6名）のため、お仕事を続けながら受講いただけます。',
  },
  {
    question: '資料請求や相談はできますか？',
    answer:
      'はい。資料請求と個別相談（オンライン可）を無料で承っています。まずはお気軽にお問い合わせください。',
  },
];

export const aboutRelatedPages = [
  {
    title: '教育理念・方針',
    description: '私たちが大切にする教育の考え方',
    href: '/philosophy',
  },
  {
    title: '全日本執事協会について',
    description: '運営母体と提供する事業のご紹介',
    href: '/association',
  },
  {
    title: 'コース一覧・比較',
    description: '3つのコースの違いを一覧で確認',
    href: '/courses',
  },
  {
    title: '施設・設備紹介',
    description: 'お台場の本校と実習環境',
    href: '/facilities',
  },
  {
    title: 'アクセス',
    description: '校舎への行き方と完全予約制のご案内',
    href: '/access',
  },
  {
    title: '学長挨拶',
    description: '学長・執事ベルからのメッセージ',
    href: '/president',
  },
];